DR.analytics = DR.analytics || {};
DR.analytics.struct = DR.analytics.struct || {};
DR.analytics.select = DR.analytics.select || {};
/** @extends {DR._Base} */
DR.analytics.struct.Item = function(par){
	/** @private */
	this._t = 1395;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.affiliation)) this.affiliation = String(par.affiliation||'');
	if(DR._Base.is(par.coupon)) this.coupon = String(par.coupon||'');
	if(DR._Base.is(par.discount)) this.discount = (parseFloat(par.discount)||0);
	if(DR._Base.is(par.index)) this.index = (parseInt(par.index)||0);
	if(DR._Base.is(par.itemId)) this.itemId = String(par.itemId||'');
	if(DR._Base.is(par.itemListId)) this.itemListId = String(par.itemListId||'');
	if(DR._Base.is(par.itemListName)) this.itemListName = String(par.itemListName||'');
	if(DR._Base.is(par.itemName)) this.itemName = String(par.itemName||'');
	if(DR._Base.is(par.itemVariant)) this.itemVariant = String(par.itemVariant||'');
	if(DR._Base.is(par.locationId)) this.locationId = String(par.locationId||'');
	if(DR._Base.is(par.price)) this.price = (parseFloat(par.price)||0);
	if(DR._Base.is(par.quantity)) this.quantity = (parseFloat(par.quantity)||0);
};
DR._Base._types[1395] = DR.analytics.struct.Item;
DR.analytics.struct.Item[__P] = new DR._Base;
DR.analytics.struct.Item[__P][__C] = DR.analytics.struct.Item;
/** @type {String|null} */
DR.analytics.struct.Item.prototype.affiliation = null;
/** @type {String|null} */
DR.analytics.struct.Item.prototype.coupon = null;
/** @type {Number|null} */
DR.analytics.struct.Item.prototype.discount = null;
/** @type {Number|null} */
DR.analytics.struct.Item.prototype.index = null;
/** @type {String} */
DR.analytics.struct.Item.prototype.itemId = null;
/** @type {String|null} */
DR.analytics.struct.Item.prototype.itemListId = null;
/** @type {String|null} */
DR.analytics.struct.Item.prototype.itemListName = null;
/** @type {String} */
DR.analytics.struct.Item.prototype.itemName = null;
/** @type {String|null} */
DR.analytics.struct.Item.prototype.itemVariant = null;
/** @type {String|null} */
DR.analytics.struct.Item.prototype.locationId = null;
/** @type {Number|null} */
DR.analytics.struct.Item.prototype.price = null;
/** @type {Number|null} */
DR.analytics.struct.Item.prototype.quantity = null;

/** @extends {DR._Base} */
DR.analytics.struct.UserData = function(par){
	/** @private */
	this._t = 1404;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.email)) this.email = String(par.email||'');
	if(DR._Base.is(par.firstName)) this.firstName = String(par.firstName||'');
	if(DR._Base.is(par.lastName)) this.lastName = String(par.lastName||'');
	if(DR._Base.is(par.phone)) this.phone = String(par.phone||'');
};
DR._Base._types[1404] = DR.analytics.struct.UserData;
DR.analytics.struct.UserData[__P] = new DR._Base;
DR.analytics.struct.UserData[__P][__C] = DR.analytics.struct.UserData;
/** @type {String|null} */
DR.analytics.struct.UserData.prototype.email = null;
/** @type {String|null} */
DR.analytics.struct.UserData.prototype.firstName = null;
/** @type {String|null} */
DR.analytics.struct.UserData.prototype.lastName = null;
/** @type {String|null} */
DR.analytics.struct.UserData.prototype.phone = null;

/** @extends {DR._Method} */
DR.analytics.AddToCart = function(par){
	this.select = [];
	this.items = [];
	/** @private */
	this._t = 1398;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1398] = DR.analytics.AddToCart;
DR.analytics.AddToCart[__CL] = "Analytics__AddToCart";
DR.analytics.AddToCart.CURRENCY_EUR = "EUR";
DR.analytics.AddToCart[__P] = new DR._Method;
DR.analytics.AddToCart[__P][__C] = DR.analytics.AddToCart;
/** @type {String} */
DR.analytics.AddToCart.prototype.currency = null;
/** @type {String|null} */
DR.analytics.AddToCart.prototype.eventId = null;
/** @type {Array.<DR.analytics.struct.Item>} */
DR.analytics.AddToCart.prototype.items = null;
/** @type {Number} */
DR.analytics.AddToCart.prototype.value = null;

/** @extends {DR._Method} */
DR.analytics.BeginCheckout = function(par){
	this.select = [];
	this.items = [];
	/** @private */
	this._t = 1397;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1397] = DR.analytics.BeginCheckout;
DR.analytics.BeginCheckout[__CL] = "Analytics__BeginCheckout";
DR.analytics.BeginCheckout.CURRENCY_EUR = "EUR";
DR.analytics.BeginCheckout[__P] = new DR._Method;
DR.analytics.BeginCheckout[__P][__C] = DR.analytics.BeginCheckout;
/** @type {String|null} */
DR.analytics.BeginCheckout.prototype.coupon = null;
/** @type {String} */
DR.analytics.BeginCheckout.prototype.currency = null;
/** @type {String|null} */
DR.analytics.BeginCheckout.prototype.eventId = null;
/** @type {Array.<DR.analytics.struct.Item>} */
DR.analytics.BeginCheckout.prototype.items = null;
/** @type {Number} */
DR.analytics.BeginCheckout.prototype.value = null;

/** @extends {DR._Method} */
DR.analytics.EmailSignup = function(par){
	this.select = [];
	/** @private */
	this._t = 1401;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1401] = DR.analytics.EmailSignup;
DR.analytics.EmailSignup[__CL] = "Analytics__EmailSignup";
DR.analytics.EmailSignup[__P] = new DR._Method;
DR.analytics.EmailSignup[__P][__C] = DR.analytics.EmailSignup;
/** @type {String|null} */
DR.analytics.EmailSignup.prototype.eventId = null;
/** @type {DR.analytics.struct.UserData|null} */
DR.analytics.EmailSignup.prototype.userData = null;

/** @extends {DR._Method} */
DR.analytics.GenerateLead = function(par){
	this.select = [];
	/** @private */
	this._t = 1400;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1400] = DR.analytics.GenerateLead;
DR.analytics.GenerateLead[__CL] = "Analytics__GenerateLead";
DR.analytics.GenerateLead.CURRENCY_EUR = "EUR";
DR.analytics.GenerateLead[__P] = new DR._Method;
DR.analytics.GenerateLead[__P][__C] = DR.analytics.GenerateLead;
/** @type {String} */
DR.analytics.GenerateLead.prototype.currency = null;
/** @type {String|null} */
DR.analytics.GenerateLead.prototype.eventId = null;
/** @type {Array.<DR.analytics.struct.Item>|null} */
DR.analytics.GenerateLead.prototype.items = null;
/** @type {String|null} */
DR.analytics.GenerateLead.prototype.leadSource = null;
/** @type {DR.analytics.struct.UserData|null} */
DR.analytics.GenerateLead.prototype.userData = null;
/** @type {Number} */
DR.analytics.GenerateLead.prototype.value = null;

/** @extends {DR._Method} */
DR.analytics.Search = function(par){
	this.select = [];
	/** @private */
	this._t = 1399;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1399] = DR.analytics.Search;
DR.analytics.Search[__CL] = "Analytics__Search";
DR.analytics.Search[__P] = new DR._Method;
DR.analytics.Search[__P][__C] = DR.analytics.Search;
/** @type {String|null} */
DR.analytics.Search.prototype.eventId = null;
/** @type {String} */
DR.analytics.Search.prototype.searchTerm = null;

/** @extends {DR._Method} */
DR.analytics.ViewItem = function(par){
	this.select = [];
	this.items = [];
	/** @private */
	this._t = 1396;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1396] = DR.analytics.ViewItem;
DR.analytics.ViewItem[__CL] = "Analytics__ViewItem";
DR.analytics.ViewItem.CURRENCY_EUR = "EUR";
DR.analytics.ViewItem[__P] = new DR._Method;
DR.analytics.ViewItem[__P][__C] = DR.analytics.ViewItem;
/** @type {String} */
DR.analytics.ViewItem.prototype.currency = null;
/** @type {String|null} */
DR.analytics.ViewItem.prototype.eventId = null;
/** @type {Array.<DR.analytics.struct.Item>} */
DR.analytics.ViewItem.prototype.items = null;
/** @type {Number} */
DR.analytics.ViewItem.prototype.value = null;

D.loaded();